import React, { useState, useEffect } from "react";
import {
  Paper,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";
import { 
  CloudDownload, 
  Send, 
  AddCircle, 
  FileCopy, 
  Visibility, 
  PersonAdd, 
  CheckCircle 
} from "@mui/icons-material";
// import { CloudDownload, Send, AddCircle } from "@mui/icons-material";
import axios from "axios";
import dayjs from "dayjs";

const DocumentHistory = ({
  documentId,
  userData,
  open,
  onClose,
  documentData,
  history,
}) => {
  return (
    <>
      {/* Modal for Document History */}
      <Dialog open={open} onClose={onClose} maxWidth="md">
        <DialogTitle>Document History</DialogTitle>
        <DialogContent>
          <Typography variant="h6" gutterBottom>
            Document details
          </Typography>
          <Typography variant="body2">
            File name: {documentData?.fileName}
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Status: {documentData?.status === 0 ? "In preparation" : "Signed"}
          </Typography>

          <Typography variant="h6" sx={{ mt: 2 }}>
            Document history
          </Typography>
          {history?.map((entry, index) => (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                // border: "1px solid #eee",
                // borderRadius: "4px",
                padding: 1,
              }}
            >
              {/* invité */}
              <Box sx={{ alignItems: "center" }}>
                {entry?.action === "Copier" && <FileCopy sx={{ mr: 1 }} />}
                {entry?.action === "invité" && <PersonAdd sx={{ mr: 1 }} />}
                {entry?.action === "créé" && <AddCircle sx={{ mr: 1 }} />}
                {entry?.action === "Vu" && <Visibility sx={{ mr: 1 }} />}
                {entry?.action === "Téléchargé" && <CloudDownload sx={{ mr: 1 }} />}
                {entry?.action === "Complété" && <CheckCircle sx={{ mr: 1 }} />}
                <Typography variant="body2">{entry?.action}</Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography variant="body2">
                  {entry?.created_at &&
                    dayjs(entry.created_at).format("DD/MM/YYYY")}
                </Typography>
                <Typography variant="body2">
                  {entry?.created_at && dayjs(entry.created_at).format("HH:mm")}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  width: "50%",
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {entry?.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ textAlign: "flex-start" }}
                >
                  {/* {`(${entry?.email}) a copier le document.`} */}
                  {entry?.action === "Copier" && `(${entry?.email}) a copié le document.`}
                  {entry?.action === "invité" && `(${entry?.email}) a été invité à consulter le document.`}
                  {entry?.action === "créé" && `(${entry?.email}) a créé le document.`}
                  {entry?.action === "Vu" && `Vu par ${entry?.name} (${entry?.email}).`}
                  {entry?.action === "Téléchargé" && `${entry?.name} (${entry?.email}) a téléchargé le document.`}
                  {entry?.action === "Complété" && `Signé par ${entry?.name} (${entry?.email}). La signature est terminée.`}
                  </Typography>
              </Box>
            </Box>
          ))}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              // border: "1px solid #eee",
              // borderRadius: "4px",
              padding: 1,
            }}
          >
            <Box sx={{ alignItems: "center" }}>
              <AddCircle sx={{ mr: 1 }} />
              <Typography variant="body2">créé</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography variant="body2">
                {documentData?.created_at &&
                  dayjs(documentData.created_at).format("DD/MM/YYYY")}
              </Typography>
              <Typography variant="body2">
                {documentData?.created_at &&
                  dayjs(documentData.created_at).format("HH:mm")}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                width: "50%",
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                {userData?.firstname} {userData?.lastname}
              </Typography>
              <Typography
                variant="body2"
                sx={{ textAlign: "flex-start" }}
              >{`(${userData?.email}) a créé le document.`}</Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>

);
};

export default DocumentHistory;
{/* 
  'Copier',
  "invité" ---- John lee (jak420786@gmail.com) a été invité à consulter le document.
  "créé" ---- BELAW PARTNERS (contact@belawpartners.com) a créé le document
  "Vu" ---- Vu par rizwan (rizwan.ahmad@kifwat.com).
  "Téléchargé" --- rizwan (rizwan.ahmad@kifwat.com) a téléchargé le document.
  'Complété' ---- Signé par BELAW PARTNERS (contact@belawpartners.com). La signature est terminée.
  */}
